import './ViewToggle.scss';

export const ViewToggle = ({ view, setView }) => {
  return (
    <div className="view-toggle-container">
      <div className="view-toggle">
        <div className={`view-toggle-button ${view === 'photo' ? 'selected' : ''}`} onClick={() => setView('photo')}>
          Single View
        </div>
        <div className={`view-toggle-button ${view === 'album' ? 'selected' : ''}`} onClick={() => setView('album')}>
          Album View
        </div>
      </div>
    </div>
  );
};
